import { Button } from '../styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { IconSvg } from '@/components/feature/UserPermissionPage/TabPermissionManagement/styles'
import { useRecoilState } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'
import CONSTANT from '@/constant'
import { useNavigate } from 'react-router-dom'
import { useHealthClaimForm } from '@/contexts/healthClaimForm'

function ReclaimByThisClaimButton() {
  const [healthClaim, setHealthClaim] = useRecoilState(healthClaimFormAtom)
  const navigate = useNavigate()
  const { getAllFormValues } = useHealthClaimForm()

  const handleReclaim = () => {
    const draft = getAllFormValues()

    // Mark reclaim mode and keep a snapshot of current form values
    setHealthClaim({
      ...healthClaim,
      reclaim: true,
      draft,
      pendingRequestDocuments: [],
    })

    // Navigate to create page while preserving values via Recoil
    navigate(CONSTANT.ROUTES.HEALTH_CLAIM_CREATE_PAGE, {
      state: { referrer: CONSTANT.ROUTES.HEALTH_CLAIM_VIEW_PAGE },
    })
  }

  return (
    <Button onClick={handleReclaim}>
      <IconSvg src={IMAGE_URL.duplicateIcon} /> ใช้ข้อมูลนี้เคลมใหม่
    </Button>
  )
}

export default ReclaimByThisClaimButton
